import { useMemo } from 'react'
import { Row } from 'react-bootstrap'
import { FormattedMessage, useIntl } from 'react-intl'
import clsx from 'clsx'

import { Heading } from 'Components/_theme'

import NoActionsFoundImage from 'Assets/images/details/no-actions-found.svg'

import { CardAction } from './CardAction'
import { CardActionsProps } from './CardActions.types'

export const CardActions = (props: CardActionsProps) => {
  const { actions, className, type } = props
  const intl = useIntl()

  const classNames = clsx(
    'row-cols-1 g-4',
    className,
    type === 'rental' ? 'row-cols-md-2' : 'row-cols-md-4',
  )

  const areActionsEmpty = useMemo(
    () => actions.every(action => action.isHidden),
    [actions],
  )

  return (
    <Row className={classNames}>
      {areActionsEmpty && (
        <div className="w-100 d-flex flex-column align-items-center justify-content-center">
          <img
            alt={intl.formatMessage({ id: 'CardActions_noAction_title' })}
            className="Order-no-action-found"
            src={NoActionsFoundImage}
          />

          <Heading as={6} size={3}>
            <FormattedMessage id="CardActions_noAction_title" />
          </Heading>

          <p>
            <FormattedMessage
              id={
                type === 'rental'
                  ? 'CardActions_noActionRental_description'
                  : 'CardActions_noActionEmployee_description'
              }
            />
          </p>
        </div>
      )}

      {actions.map(action => (
        <CardAction key={action.id} {...action} />
      ))}
    </Row>
  )
}
